var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('span', { staticClass: "range-tips" }, [_vm._v(_vm._s(_vm.innerLabel) + "\n  "), _c('auto-tips', { attrs: { "tooltipProps": { effect: 'dark' }, "content": _vm.tipsLabel, "max-length": 0 } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };